import { LOADING_VIDEO_URL } from './components/public/LoadingAnimation';

let loaderShownAt = null;

export const getLoaderShownAt = () => loaderShownAt ?? Date.now();

export function showGlobalLoader(show = true) {
  if (show && loaderShownAt === null) {
    loaderShownAt = Date.now();
  }

  let el = document.getElementById('global-loader-overlay');
  if (!el) {
    el = document.createElement('div');
    el.id = 'global-loader-overlay';
    el.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:center;width:100%;height:100%">
        <video
          src="${LOADING_VIDEO_URL}"
          autoplay
          loop
          muted
          playsinline
          preload="auto"
          style="width:min(95vw,560px);max-width:600px;height:auto;display:block"
        ></video>
      </div>
    `;
    document.body.appendChild(el);
  }
  el.classList.toggle('active', show);

  if (show) {
    document.body.classList.add('loading');
    const video = el.querySelector('video');
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {});
    }
  } else {
    document.body.classList.remove('loading');
    const video = el.querySelector('video');
    if (video) video.pause();
  }
}
